import {
  getSiniestros as axiosGetSiniestros,
  postSiniestro as axiosPostSiniestro,
} from '../../axios/Siniestro';
import { GET_SINIESTROS } from '../../axios/Utils/constants';
import { Siniestro, SiniestroReq } from '../../types/Siniestro/types';
import { useCreateEntity, useFetchEntity } from '../Utils/useEntity';

export const usePostSiniestro = () => {
  const { create, isLoading, error } = useCreateEntity<
    SiniestroReq,
    { ok: boolean; data?: SiniestroReq; error?: string }
  >(axiosPostSiniestro);

  return { postSiniestro: create, isLoading, error };
};

export const useGetSiniestros = (petId?: string) => {
  const key = petId ? `${GET_SINIESTROS}-${petId}` : null; // ✅ Solo hace fetch si hay petId

  const { data, error, isValidating, mutate } = useFetchEntity<Siniestro[]>(
    key,
    async () => {
      const res = await axiosGetSiniestros(petId as string);
      return res.data;
    },
  );

  return {
    siniestros: data,
    error,
    isValidating,
    mutate,
  };
};
